import { render, staticRenderFns } from "./routerPage.vue?vue&type=template&id=08d79981&"
import script from "./routerPage.vue?vue&type=script&lang=js&"
export * from "./routerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports